export default {
  oidc: {
    clientId: window.VITE_OKTA_CLIENT_ID || "0oa9lyg32nWWUU68y0x7",
    issuer: window.VITE_OKTA_ISSUER || "https://sso.preview.sprengnetter.de/oauth2/default",
    redirectUri: window.VITE_OKTA_REDIRECT_URI || "http://localhost:3000/login/callback",
    postLogoutRedirectUri: window.VITE_OKTA_POST_LOGOUT_REDIRECT_URI || "http://localhost:3000/logout",
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
    disableHttpsCheck: false,
  },
};
